import { attachmentSummaries } from './attachments';
import { blockSummaries } from './blocks';
import { commentSummaries } from './comments';
import { endorsementSummaries } from './endorsements';
import { guidanceSummaries } from './guidance';
import { librarySummaries } from './library';
import { partSummaries } from './parts';
import { renewalSummarySummaries } from './renewalSummary';
import { resourceSummaries } from './resource';
import type { ActionName, SummaryRenderer } from './types';

export type { SummaryContext } from './context';
export { buildSummaryContext } from './context';

type SummaryRenderers = { [K in ActionName]: SummaryRenderer<K> };

/**
 * One renderer per catalogue action — the annotation makes a missing action a compile
 * error, so a new `AuditAction` variant cannot ship without its message.
 */
const SUMMARY_RENDERERS: SummaryRenderers = {
  ...resourceSummaries,
  ...blockSummaries,
  ...partSummaries,
  ...attachmentSummaries,
  ...commentSummaries,
  ...endorsementSummaries,
  ...librarySummaries,
  ...guidanceSummaries,
  ...renewalSummarySummaries,
};

// The registry is exhaustive, but the caller's entry is an already-widened union, so the
// variant↔renderer correlation is asserted once here (microsoft/TypeScript#30581) — and the
// server can emit actions newer than this client's union, hence the optional result.
export const getSummaryRenderer = (action: ActionName): SummaryRenderer<ActionName> | undefined =>
  (SUMMARY_RENDERERS as Partial<Record<string, SummaryRenderer<ActionName>>>)[action];
